import { css } from '@/styled-system/css';

export const container = css({
  width: '100%',
  '& [data-testid="listing-card"]': {
    height: '100%',
  },
});

export const carouselItem = css({
  // eslint-disable-next-line hotpads/no-magic-numbers -- matches established ListingCarousel card rhythm
  width: '280px',
  sm: {
    // eslint-disable-next-line hotpads/no-magic-numbers -- matches established ListingCarousel card rhythm
    width: '300px',
  },
  md: {
    // eslint-disable-next-line hotpads/no-magic-numbers -- matches established ListingCarousel card rhythm
    width: '340px',
  },
});

export const loadingRow = css({
  display: 'flex',
  gap: 'default',
  overflow: 'hidden',
});

export const loadingCard = css({
  flex: 'none',
  // eslint-disable-next-line hotpads/no-magic-numbers -- aligns with listing-card skeleton width
  width: '300px',
  // eslint-disable-next-line hotpads/no-magic-numbers -- aligns with listing-card skeleton height
  height: '220px',
  borderRadius: 'md',
  background: 'bg.softest',
});
